import { render, staticRenderFns } from "./keyWordsDetail.vue?vue&type=template&id=505d58fa&scoped=true&"
import script from "./keyWordsDetail.vue?vue&type=script&lang=js&"
export * from "./keyWordsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d58fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505d58fa')) {
      api.createRecord('505d58fa', component.options)
    } else {
      api.reload('505d58fa', component.options)
    }
    module.hot.accept("./keyWordsDetail.vue?vue&type=template&id=505d58fa&scoped=true&", function () {
      api.rerender('505d58fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonKeyWords/keyWordsDetail.vue"
export default component.exports